export default "__VITE_PUBLIC_ASSET__365a31da__"